<template>
<div>
    <router-view/>
</div>
</template>

<script>
export default {
  name: 'Resident',
  data () {
    return {
    }
  },
}
</script>

<style lang="scss">
</style>
© 2020 GitHub, Inc.